// extracted by mini-css-extract-plugin
module.exports = {"socialMidia":"social-midia_socialMidia__lfWEL","iconContainer":"social-midia_iconContainer__1WWJH","icon":"social-midia_icon__1g25X"};